// extracted by mini-css-extract-plugin
export default {"formWrapper":"style_formWrapper__PNhKG","title":"style_title__IJzWO","forgotPassword":"style_forgotPassword__1d3yD","button":"style_button__K4y5Y"};